var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("loading", {
        attrs: { active: _vm.isLoading, loader: "dots" },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c(
        "div",
        { staticClass: "fixed-list-item" },
        [
          _c("eva-icon", {
            attrs: { fill: "#000", name: "refresh-outline" },
            on: {
              click: function ($event) {
                return _vm.reload()
              },
            },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "card search-card" }, [
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "form-row" }, [
            _c("div", { staticClass: "col-sm-3 col-md-3" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "" } }, [_vm._v("面談日期")]),
                  _c(
                    "el-date-picker",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        "value-format": "yyyy-MM-dd",
                        type: "daterange",
                        "start-placeholder": "開始日期",
                        "end-placeholder": "結束日期",
                      },
                      model: {
                        value: _vm.search.RangeDate,
                        callback: function ($$v) {
                          _vm.$set(_vm.search, "RangeDate", $$v)
                        },
                        expression: "search.RangeDate",
                      },
                    },
                    [_vm._v(" > ")]
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "col-sm-3 col-md-3" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "search-name" } }, [
                    _vm._v("面談流程"),
                  ]),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: "請選擇",
                      },
                      model: {
                        value: _vm.search.BaseFlowGuid,
                        callback: function ($$v) {
                          _vm.$set(_vm.search, "BaseFlowGuid", $$v)
                        },
                        expression: "search.BaseFlowGuid",
                      },
                    },
                    _vm._l(_vm.flowList, function (item) {
                      return _c("el-option", {
                        key: item.Value,
                        attrs: { label: item.Text, value: item.Value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "col-sm-3 col-md-3" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "search-name" } }, [
                    _vm._v("招募窗口"),
                  ]),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        filterable: "",
                        clearable: "",
                        placeholder: "請選擇",
                      },
                      model: {
                        value: _vm.search.ContactPersonGuid,
                        callback: function ($$v) {
                          _vm.$set(_vm.search, "ContactPersonGuid", $$v)
                        },
                        expression: "search.ContactPersonGuid",
                      },
                    },
                    _vm._l(_vm.contactList, function (item) {
                      return _c("el-option", {
                        key: item.Value,
                        attrs: { label: item.Text, value: item.Value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "col-sm-3 col-md-3" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "search-name" } }, [
                  _vm._v("姓名"),
                ]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.search.Name,
                      expression: "search.Name",
                      modifiers: { trim: true },
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    type: "text",
                    id: "search-name",
                    placeholder: "請輸入關鍵字",
                  },
                  domProps: { value: _vm.search.Name },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.search, "Name", $event.target.value.trim())
                    },
                    blur: function ($event) {
                      return _vm.$forceUpdate()
                    },
                  },
                }),
              ]),
            ]),
            _c("div", { staticClass: "col-sm-3 col-md-3" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "" } }, [_vm._v("應徵職務")]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.search.ManpowerDemandName,
                      expression: "search.ManpowerDemandName",
                      modifiers: { trim: true },
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", placeholder: "請輸入關鍵字" },
                  domProps: { value: _vm.search.ManpowerDemandName },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.search,
                        "ManpowerDemandName",
                        $event.target.value.trim()
                      )
                    },
                    blur: function ($event) {
                      return _vm.$forceUpdate()
                    },
                  },
                }),
              ]),
            ]),
            _c("div", { staticClass: "col-sm-3 col-md-3" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  staticStyle: { "margin-top": "30px", "margin-right": "5px" },
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.getData()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Search")) + " ")]
              ),
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  staticStyle: { "margin-top": "30px", "margin-right": "5px" },
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      _vm.search = {
                        RangeDate: _vm.search.RangeDate,
                      }
                    },
                  },
                },
                [_vm._v(" 清除 ")]
              ),
            ]),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "text-right mb-2" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.exportExcel },
            },
            [_vm._v("匯出")]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "yahome-table-wrap" },
        [
          _vm.tableData
            ? _c(
                "el-table",
                { attrs: { data: _vm.tableData.ReportFlows, height: "450px" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "Name", label: "姓名", sortable: "" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "IdNo", label: "身分證字號", sortable: "" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "ManpowerDemandName",
                      label: "應徵職務",
                      width: "120",
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "ContactPersonName",
                      label: "招募窗口",
                      width: "120",
                      sortable: "",
                      "sort-method": (a, b) =>
                        _vm.defaultSort(a, b, "ContactPersonName"),
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "HrManagerName",
                      label: "HR主管",
                      width: "120",
                      sortable: "",
                      "sort-method": (a, b) =>
                        _vm.defaultSort(a, b, "HrManagerName"),
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "InterviewManagerName",
                      label: "面談主管",
                      width: "120",
                      sortable: "",
                      "sort-method": (a, b) =>
                        _vm.defaultSort(a, b, "InterviewManagerName"),
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "BaseFlowName",
                      label: "使用流程",
                      width: "120",
                      sortable: "",
                      "sort-method": (a, b) =>
                        _vm.defaultSort(a, b, "BaseFlowName"),
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "InvitationTime",
                      label: "面談日期",
                      width: "120",
                      sortable: "",
                      formatter: _vm.dateFormatter,
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "TemporaryTime",
                      label: "臨時到廠時間",
                      width: "120",
                      sortable: "",
                      formatter: _vm.timeFormatter,
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "CheckInTime",
                      label: "報到時間",
                      width: "120",
                      sortable: "",
                      formatter: _vm.timeFormatter,
                      "sort-method": (a, b) =>
                        _vm.defaultSort(a, b, "CheckInTime"),
                    },
                  }),
                  _vm._l(
                    _vm.tableData.DynamicStageHeader,
                    function (DynamicStageHeader, index) {
                      return [
                        _c(
                          "el-table-column",
                          {
                            key: index + "startTime",
                            attrs: {
                              width: "90",
                              label: DynamicStageHeader.Name,
                              formatter: _vm.filterStartTime,
                            },
                          },
                          [
                            _c("template", { slot: "header" }, [
                              _vm._v(
                                " " +
                                  _vm._s(DynamicStageHeader.Name) +
                                  "-開始時間 "
                              ),
                            ]),
                          ],
                          2
                        ),
                        _c(
                          "el-table-column",
                          {
                            key: index + "endTime",
                            attrs: {
                              width: "90",
                              label: DynamicStageHeader.Name,
                              formatter: _vm.filterEndTime,
                            },
                          },
                          [
                            _c("template", { slot: "header" }, [
                              _vm._v(
                                " " +
                                  _vm._s(DynamicStageHeader.Name) +
                                  "-結束時間 "
                              ),
                            ]),
                          ],
                          2
                        ),
                        DynamicStageHeader.Type === 2
                          ? _c(
                              "el-table-column",
                              {
                                key: index + "person",
                                attrs: {
                                  width: "90",
                                  label: DynamicStageHeader.Name,
                                  formatter: _vm.filterPerson,
                                },
                              },
                              [
                                _c("template", { slot: "header" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(DynamicStageHeader.Name) +
                                      "-" +
                                      _vm._s(
                                        DynamicStageHeader.InterviewUserType
                                      ) +
                                      " "
                                  ),
                                ]),
                              ],
                              2
                            )
                          : _vm._e(),
                        _c(
                          "el-table-column",
                          {
                            key: index + "IsOverTime",
                            attrs: {
                              width: "90",
                              label: DynamicStageHeader.Name,
                              formatter: _vm.filterIsOverTime,
                            },
                          },
                          [
                            _c("template", { slot: "header" }, [
                              _vm._v(
                                " " +
                                  _vm._s(DynamicStageHeader.Name) +
                                  "-是否超時 "
                              ),
                            ]),
                          ],
                          2
                        ),
                      ]
                    }
                  ),
                  _c("el-table-column", {
                    attrs: {
                      prop: "FinishTime",
                      label: "離場時間",
                      width: "120",
                      sortable: "",
                      formatter: _vm.timeFormatter,
                      "sort-method": (a, b) =>
                        _vm.defaultSort(a, b, "FinishTime"),
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "IsForceCancel",
                      label: "強制結案",
                      width: "120",
                      sortable: "",
                      formatter: _vm.timeFormatter,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              props.row.IsForceCancel === true
                                ? _c("span", [_vm._v("是")])
                                : _c("span", [_vm._v("否")]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      546725951
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "FinishRemark",
                      label: "結案備註",
                      sortable: "",
                    },
                  }),
                ],
                2
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }